import { render, staticRenderFns } from "./SobrePage.vue?vue&type=template&id=76f89818&scoped=true"
import script from "./SobrePage.vue?vue&type=script&lang=js"
export * from "./SobrePage.vue?vue&type=script&lang=js"
import style0 from "./SobrePage.vue?vue&type=style&index=0&id=76f89818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f89818",
  null
  
)

export default component.exports